import { apiSlice } from '../api-slice';

export const expiryAdjustmentApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getExpiredItemsByProducts: builder.query({
            query: (params) => {
                return {
                    url: 'inventory/expiry-adjustments/products',
                    method: 'GET',
                    params,
                };
            },
            // providesTags: [SLICE_TAG.INVENTORY_LOW_STOCK],
            // keepUnusedDataFor: 600,
            // transformResponse(response) {
            //     return LowStockListResponseSchema.parse(response);
            // },
        }),

        getExpiredItemsByProductIds: builder.query({
            query: (id) => {
                return {
                    url: `inventory/expiry-adjustments/products/${id}`,
                    method: 'GET',
                };
            },
        }),

        restockExpiredItems: builder.mutation({
            query: (data) => {
                return {
                    url: `purchases/restock-expired-items`,
                    method: 'PUT',
                    body: data,
                };
            },
        }),
    }),
});

export const {
    useGetExpiredItemsByProductsQuery,
    useLazyGetExpiredItemsByProductsQuery,
    useGetExpiredItemsByProductIdsQuery,
    useLazyGetExpiredItemsByProductIdsQuery,

    useRestockExpiredItemsMutation,
} = expiryAdjustmentApiSlice;
